export default "__VITE_ASSET__CcP7yl0Q__"